








import LegalAgreements from '@/components/Templates/Admin/Settings/LegalAgreements/LegalAgreements.vue';

export default {
    name: 'PrivacyPolicy',
    components: {
        LegalAgreements,
    },
};
